"use strict";

exports.__esModule = true;
exports.TIME_FILTER_SEGMENTS = exports.STOP_FILTER_CODE_MAP = exports.QUICK_FILTER_ID_MAP = exports.QUICK_FILTERS = exports.FLIGHT_LEG_TYPE_MAP = exports.FILTER_SPECIAL_MAP = exports.FILTER_SEPARATOR_MAP = exports.FILTER_PARAM_MAP = exports.FILTER_MAP = exports.DEFAULT_FILTER_KEYS = exports.BAGGAGE_FILTER_CODE_MAP = void 0;
var _FILTER_PARAM_MAP;
var FILTER_MAP = exports.FILTER_MAP = {
  PRICE: 'price',
  STOP: 'stop',
  AIRLINE: 'airline',
  AIRPORT: 'airport',
  BAGGAGE: 'baggage',
  TIME: 'time'
};
var FILTER_PARAM_MAP = exports.FILTER_PARAM_MAP = (_FILTER_PARAM_MAP = {}, _FILTER_PARAM_MAP[FILTER_MAP.PRICE] = 'p', _FILTER_PARAM_MAP[FILTER_MAP.STOP] = 's', _FILTER_PARAM_MAP[FILTER_MAP.AIRLINE] = 'ar', _FILTER_PARAM_MAP[FILTER_MAP.AIRPORT] = 'ap', _FILTER_PARAM_MAP[FILTER_MAP.BAGGAGE] = 'bg', _FILTER_PARAM_MAP[FILTER_MAP.TIME] = 't', _FILTER_PARAM_MAP);
var FILTER_SEPARATOR_MAP = exports.FILTER_SEPARATOR_MAP = {
  MULTI_SELECT: ',',
  RANGE: '-',
  LEG: '*',
  DIRECTION: ';'
};
var FILTER_SPECIAL_MAP = exports.FILTER_SPECIAL_MAP = {
  SELECT_ALL: 'all',
  DIRECTION_SELECT_ALL: 'all;all'
};
var FLIGHT_LEG_TYPE_MAP = exports.FLIGHT_LEG_TYPE_MAP = {
  ORIGIN: 'origin',
  DESTINATION: 'destination'
};
var QUICK_FILTER_ID_MAP = exports.QUICK_FILTER_ID_MAP = {
  DIRECT_ONLY: 'directOnly',
  BAGGAGE_ONLY: 'hasBaggageOnly'
};
var QUICK_FILTERS = exports.QUICK_FILTERS = [{
  id: QUICK_FILTER_ID_MAP.DIRECT_ONLY,
  filter: FILTER_MAP.STOP,
  toggleMethod: 'toggleDirectOnly'
}, {
  id: QUICK_FILTER_ID_MAP.BAGGAGE_ONLY,
  filter: FILTER_MAP.BAGGAGE,
  toggleMethod: 'toggleHasBaggageOnly'
}];
var STOP_FILTER_CODE_MAP = exports.STOP_FILTER_CODE_MAP = {
  DIRECT_ONLY: 0,
  ONE_STOP_PLUS: 1,
  TWO_STOPS_PLUS: 2
};
var BAGGAGE_FILTER_CODE_MAP = exports.BAGGAGE_FILTER_CODE_MAP = {
  HAS_CHECKED_BAGGAGE: 'true',
  HAS_NOT_CHECKED_BAGGAGE: 'false'
};
var DEFAULT_FILTER_KEYS = exports.DEFAULT_FILTER_KEYS = ['price', 'maxStop', 'time', 'airport', 'airline', 'baggage'];
var TIME_FILTER_SEGMENTS = exports.TIME_FILTER_SEGMENTS = {
  AM: {
    code: 'am',
    from: 0,
    to: 5
  },
  AM2: {
    code: 'am2',
    from: 6,
    to: 11
  },
  PM: {
    code: 'pm',
    from: 12,
    to: 17
  },
  PM2: {
    code: 'pm2',
    from: 18,
    to: 23
  }
};